// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"b7a16697","52":"51909ca8","317":"3871dea1","351":"fc9c1f69","593":"8e278374","691":"e7afe4fc","751":"f1cfb570","752":"280b2097","926":"73708aa9","983":"24f979fa","991":"5303a9a7"}[chunkId] + ".chunk.css";
};